<script setup lang="ts">
import type { Validate } from '@/shared/types/validation.types'

interface Props {
  id: string
  text?: string
  required?: boolean
  disabled?: boolean
  validate?: Validate
}

defineProps<Props>()
</script>

<template>
  <label
    :for="id"
    class="text-xs"
    :class="[
      validate?.isDirty && validate?.isInvalid
        ? 'text-error'
        : disabled
          ? 'text-gray-400 dark:text-gray-800'
          : 'text-gray-700 dark:text-gray-300',
    ]"
  >
    {{ text }}
    <span v-if="required" class="font-medium text-sm text-error">*</span>
  </label>
</template>
